/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { AiOutlineLeft } from 'react-icons/ai';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Button, FiltersSlide, Loader } from 'ypf-pas-general-ui-components';
import { MdFilterAlt } from 'react-icons/md';

import DataSheet from '../../components/DataSheet/DataSheet';
import InputUnitMeasureColumn from '../../components/DataSheet/CustomColumns/InputUnitMeasure/InputUnitMeasureColumn';
import RowDefinerColumn from '../../components/DataSheet/CustomColumns/RowDefinerColumn/RowDefinerColumn';
import GroupColumn from '../../components/DataSheet/CustomColumns/GroupColumn/GroupColumn';
import useSimplifiedCharging from '../../hooks/useSimplifiedCharging/useSimplifiedCharging';
import { checkRol } from '../../security';
import { consultaServicios, proveedorNotificador, solicitante } from '../../security/constantsRols';
import FilterWorkReport from '../../components/WorkReports/FilterWorkReports/FilterWorkReport';
import { useFilterContext } from '../../context/FilterDetailSDSContext';
import NotFoundData from '../../components/NotFoundData/NotFoundData';

import { getFirstDayOfAMonth, getLastDayOfAMonth, getAllDays } from './utils';

import './SimplifiedCharging.scss';

const SimplifiedCharging = () => {
  const [columnsForSheet, setDataColumnsForSheet] = useState([]);
  const [showFilters, setShowFilters] = useState(false);

  const [equipment] = useState(() => {
    const storedSelect = sessionStorage.getItem('equipoSeleccionado');
    const storedParse = JSON.parse(storedSelect);

    return storedParse || null;
  });

  const { id, month, year, isOrderByUbication, number } = useParams();

  const history = useHistory();
  const { disabled } = useLocation();
  const { formikFilters } = useFilterContext();
  const { setFieldValue } = formikFilters;
  const [options, setOptions] = useState(null);

  useEffect(() => {
    if (equipment)
      setOptions([
        {
          filter: equipment?.nombre,
          key: equipment?.id,
          id: equipment?.id
        }
      ]);
  }, []);

  const {
    dataForSheet,
    loading,
    forceWindow,
    getDataForSheet,
    setDataForSheet,
    setLoading,
    linesByUbication,
    linesByPostionLIne,
    hasTechnicalLocations
  } = useSimplifiedCharging({
    id,
    isOrderByUbication,
    idEquipment: equipment?.id
  });

  const disabledAllEdition = disabled || checkRol(solicitante) || checkRol(consultaServicios);

  const daysKeysForColumns = getAllDays(
    'es-AR',
    getFirstDayOfAMonth(month, year),
    getLastDayOfAMonth(month, year),
    'dd/mm/yy'
  );

  const daysTitlesForColumns = getAllDays(
    'es-AR',
    getFirstDayOfAMonth(month, year),
    getLastDayOfAMonth(month, year),
    'Day number'
  );

  const setColumns = useCallback(
    (columnsDataDays, tieneUbicacionesTecnicas) => {
      columnsDataDays.unshift({
        keyColumn: 'rowDefiner',
        title: '',
        typeOfColumn: RowDefinerColumn(isOrderByUbication)
      });
      columnsDataDays.unshift({
        keyColumn: 'group',
        title: '',
        typeOfColumn: GroupColumn({
          isOrderByUbication,
          tieneUbicacionesTecnicas
        })
      });
      setDataColumnsForSheet(columnsDataDays);
    },
    [isOrderByUbication]
  );

  useEffect(() => {
    const columnsDataDays = daysKeysForColumns.map((dayKey, index) => ({
      keyColumn: dayKey,
      title: daysTitlesForColumns[index],
      typeOfColumn: InputUnitMeasureColumn({
        disabledAllEdition,
        forceWindow
      })
    }));

    setColumns(columnsDataDays, hasTechnicalLocations);
  }, [forceWindow, hasTechnicalLocations]);

  const deleteFilter = () => {
    sessionStorage.setItem('equipoSeleccionado', null);
    setOptions([]);
    setDataForSheet([]);
    getDataForSheet();
  };
  const hideModalFilters = () => {
    setShowFilters(false);
  };

  return (
    <>
      <div>
        <FilterWorkReport
          hide={hideModalFilters}
          isOrderByUbication={isOrderByUbication !== 'false'}
          show={showFilters}
        />
      </div>
      {loading ? (
        <Loader show={loading || !dataForSheet?.length} text="CARGANDO" />
      ) : (
        <div>
          {month && year ? (
            <>
              <div
                className={`request-title
                  ${isOrderByUbication === 'true' ? 'ubication' : 'position'}`}
              >
                <AiOutlineLeft
                  className="mx-2"
                  onClick={() => {
                    setFieldValue('haveFilters', false);
                    history.push(`/detailmonthly/${id}`);
                  }}
                />
                {checkRol(proveedorNotificador) && (
                  <Button
                    className="button-filters"
                    color="primary"
                    icon={MdFilterAlt}
                    onClick={() => setShowFilters(true)}
                    sizeIcon="20px"
                    type="button"
                    variant="white"
                    widthButton="30px"
                  >
                    Filtros
                  </Button>
                )}
                <div className="mx-2">{`Solicitud de servicio N° ${number} - `}</div>
                <div
                  style={{
                    color: '#000'
                  }}
                >
                  {' '}
                  {month} {year}
                </div>
                {isOrderByUbication === 'true' && options?.length > 0 && (
                  <div className="position-relative" style={{ display: 'flex' }}>
                    <div
                      style={{
                        marginLeft: '30px',
                        marginRight: '20px'
                      }}
                    >
                      Filtro
                    </div>
                    <FiltersSlide arrayFilters={options} onDelete={() => deleteFilter()} />
                  </div>
                )}
              </div>
            </>
          ) : null}
          {dataForSheet?.length && dataForSheet.some((data) => data.children?.length > 0) ? (
            <>
              <DataSheet
                columns={columnsForSheet}
                disabled={disabledAllEdition}
                id={id}
                initialGroups={dataForSheet}
                isOrderByUbication={isOrderByUbication}
                linesByPostionLIne={linesByPostionLIne}
                linesByUbication={linesByUbication}
                onSend={() => getDataForSheet(equipment?.id)}
                setLoading={setLoading}
              />
            </>
          ) : (
            <div className="request-body">
              <NotFoundData />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default SimplifiedCharging;
